import React from "react";
import { SELECT_HERE_TEXT, VALUE_OF_OPTION_CHOOSE_ONE } from "./constants";

const Select = ({
  options,
  optionlabel,
  defaultOptionText,
  onBlur,
  ...props
}) => {
  return (
    <select {...props}>
      <option value={VALUE_OF_OPTION_CHOOSE_ONE}>
        {defaultOptionText ? defaultOptionText : SELECT_HERE_TEXT}
      </option>
      {options.map((option) => (
        <option value={option.id} key={option.id}>
          {option[optionlabel]}
        </option>
      ))}
    </select>
  );
};

export default Select;
